import React from "react"

import * as styles from "./PanelWrapper.module.css"
import { BackgroundKeyToColor, GeneralSizeKeyToPaddingNumber, GeneralHeightKeyToBarHeight } from "../../../utils/datasources"

const PanelWrapper = ({ blok, children }) => {
  const backgroundColor = BackgroundKeyToColor(blok.background_color),
        barTopColor = BackgroundKeyToColor(blok.bar_color_top),
        barBottomColor = BackgroundKeyToColor(blok.bar_color_bottom),
        barTopSize = GeneralHeightKeyToBarHeight(blok.bar_height_top),
        barBottomSize = GeneralHeightKeyToBarHeight(blok.bar_height_bottom),
        paddingTop = GeneralSizeKeyToPaddingNumber(blok.padding_top),
        paddingBot = GeneralSizeKeyToPaddingNumber(blok.padding_bottom)

  return (
    <div className={blok.full_width ? styles.wrapper + " " + styles.container: styles.container} style={{paddingTop: paddingTop, paddingBottom: paddingBot, backgroundColor: backgroundColor}} id={blok?.anchor_id ? blok.anchor_id : blok?.html_anchor}>
      <div className={styles.content}>
        {children}
      </div>
      <div className={styles.topbar} style={{height: barTopSize, backgroundColor: barTopColor}}></div>
      <div className={styles.bottombar} style={{height: barBottomSize, backgroundColor: barBottomColor}}></div>
    </div>
  )
}

export default PanelWrapper